import { CheckCircleIcon } from '@heroicons/react/24/solid';
import Button from '@/components/UI/Button';

const PasswordResetRequested = ({ forwardHandler }: { forwardHandler: () => void }) => {
  return (
    <div className='flex flex-col gap-5  max-w-md w-11/12 md:w-1/2 lg:w-1/2 xl:w-1/4 bg-white shadow-lg rounded-lg px-8 py-5 border-t-2'>
      <div className='flex gap-2 items-center'>
        <CheckCircleIcon className='h-6 w-6 text-primaryColor-normal' />
        <h2 className='text-primaryColor-normal m-0'>Success</h2>
      </div>
      <p>
        If an account exists with us. you will get an email with instructions on resetting your password. If it doesn't arrive, be sure to
        check your spam folder.
      </p>
      <Button label='Back to Sign In' btnStyle='btn-primary' type='button' onClick={forwardHandler} />
    </div>
  );
};

export default PasswordResetRequested;
